module.exports = __webpack_public_path__ + "images/external_images/img/demo/job/office-4.jpg";